/// src/pages/HistoryPageChina.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Ancient_Civilizations_-_Ancient_Egypt.png';

export default function HistoryPageChina() {
  return (
    <TopicPage
      topicKey="Ancient Egypt"
      title="History: Ancient Egypt"
      backgroundImage={bg}
      startRoute="/History-Ancient-Egypt-Go"
      scrollLabels={[
        "Pharoes, Gods, Architecture.",
      ]}

  backRoute="/history-Ancient-Civilizations"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
